import { createSelector } from 'reselect';

export const getMachineSchedule = (state) => {
  return state.machineSchedule;
};

export const getMachineScheduleWooRefs = createSelector(
  [getMachineSchedule],
  (machineSchedule) => {
    return (
      machineSchedule?.map(({ workOrderOperationRef }) => {
        return workOrderOperationRef;
      }) || []
    );
  }
);
